<template>
  <data-list
    ref="dataList"
    class="content md"
    url="/activity/activity-spot"
    entity-name="点位"
    add-btn="添加点位"
    hide-show-detail
    :before-update="beforeUpdate"
    :deal-list="dealList"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules"
    :modal-width="480"
    :search-key-type="{name: 1}"
    v-if="activity">
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-input v-model="form.name" placeholder="输入点位名称搜索" style="width: 200px"></a-input>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="点位名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入点位名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="点位类型" prop="type">
        <a-radio-group v-model="form.type" :options="locationTypeList"/>
      </a-form-model-item>
      <a-form-model-item label="点位地址" prop="position">
        <coordinate-picker v-model="form.position" />
      </a-form-model-item>
      <a-form-model-item label="点位图片">
        <form-upload v-model="form.img" :limit="3" />
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import mixins from "./mixins";
    import {getKeyTitle} from "../../common/js/tool";

    const locationTypeList = [
        { label:'导览', value: 1 },
        { label:'酒店', value: 2 }
    ]

    export default {
        name: "ActivityLocation",
        data() {
            return {
                locationTypeList,
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '点位类型', dataIndex: 'type', customRender: text => getKeyTitle(locationTypeList, text, 'value', 'label')},
                    {title: '点位地址',  dataIndex: 'position', customRender: text => text ? text.address : "--"},
                ],
                rules: {
                    name: [{ required: true, message: '请输入点位名称', trigger: 'blur' }],
                    type: [{ required: true, message: '请选择点位地址', trigger: 'change' }],
                    position: [{ required: true, message: '请选择点位类型', trigger: 'change' }],
                    img: [{ required: true, message: '请上传点位图片', trigger: 'change' }],
                },
                visible: false,
                moduleKey: 'location',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            dealList(list, fn) {
                list.forEach(item => {
                    if(item.location) {
                        item.position = JSON.parse(item.location);
                    }
                })
                fn();
            },
            beforeUpdate(form, fn) {
                const data = {
                    name: form.name,
                    type: form.type,
                    location: JSON.stringify(form.position),
                    img: form.img
                }
                if(form.id) {
                    data.id = form.id;
                } else {
                    data.activity_id = this.activity.id;
                }
                fn(data);
            },
        }
    }
</script>

<style lang="less">
</style>
